import { ContentType } from '@sr/types';

type Labels = {
  title?: string;
  subtitle?: string;
  website?: string;
  inlinePlaceholder?: string;
  add?: string;
};

type LabelKeys = 'title' | 'subtitle' | 'website' | 'inlinePlaceholder' | 'add';

function getContentTypeLabel(
  label: LabelKeys,
  contentType: ContentType
): string {
  const labels: Partial<Record<ContentType, Labels>> = {
    conference: {
      title: 'Conference Name',
      subtitle: 'Conference Info',
      website: 'Conference Website',
      add: 'Add Conference',
    },
    education: {
      title: 'School',
      subtitle: 'Degree & Major',
      website: 'School Website',
      add: 'Add Education',
    },
    hobbies: {
      title: 'Hobby',
      inlinePlaceholder: 'Add one hobbie on each line',
    },
    internships: {
      add: 'Add Internship',
    },
    languages: {
      title: 'Language',
      subtitle: 'Proficiency',
      add: 'Add Language',
    },
    patents: {
      title: 'Patent title',
      subtitle: 'Patent description',
      website: 'Patent Website',
      add: 'Add Patent',
    },
    projects: {
      title: 'Project Name',
      subtitle: 'Role',
      add: 'Add Project',
    },
    references: {
      title: 'Name',
      subtitle: 'Contact Info',
      website: 'Reference Website',
      add: 'Add Reference',
    },
    skills: {
      title: 'Skill',
      inlinePlaceholder: 'Add one skill on each line',
    },
    volunteering: {
      add: 'Add Volunteering Experience',
    },
    'work-experience': {
      title: 'Company',
      subtitle: 'Job Title',
      website: 'Company Website',
      add: 'Add Job',
    },
  };
  const defaultLabels = {
    title: 'Title',
    subtitle: 'Subtitle',
    website: 'Website',
    inlinePlaceholder: 'Add one item on each line',
    add: 'Add item',
  };
  const labelsForType = labels[contentType];
  if (labelsForType && labelsForType[label]) {
    const value = labelsForType[label];
    if (value) {
      return value;
    } else {
      return defaultLabels[label] || '';
    }
  } else {
    return defaultLabels[label] || '';
  }
}

export default getContentTypeLabel;
